window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    var instance = new Swiper('.city-location-list__wrapper .swiper', {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 8,
      slidesOffsetBefore: 18,
      slidesOffsetAfter: 18,
      breakpoints: {
        1280: {
          spaceBetween: 12,
        },
      },
    });
  });
});
